import { AllergenValues } from './allergen-values.model';
import { NutritionValues } from './nutrition-values';
import { ModelBase } from './model-base';

export enum PortionSizes {
  None = 0,
  Small = 1,
  Regular = 1 << 1,
  Large = 1 << 2,
}

export class RecipeSearchResult extends ModelBase {

  id: number;
  name: string;
  portionMeasure: string;
  allergens: AllergenValues;
  nutrition: NutritionValues;
  portionSize: number;
  description: string;
  photoUrl: string;
  co2eValue: number;
  co2eValueComplete: boolean;

  /** Returns true if a value is present for all nutrients */
  nutritionComplete: boolean;

  /** Returns true if a (contains / may contain / does not contain) value is present for all allergens */
  allergensComplete: boolean;

  /** A bit flag that indicates whether allergen and/or nutrient data should be displayed
   * 0: neither should be displayed
   * 1: nutrient data should be displayed where complete
   * 2: allergen data should be displayed where complete
   * 3: both should be displayed where possible
   */
  publicNutrition: number;

  usePhoto: boolean;
  displayFoodPortalPrice: boolean;
  foodPortalPrice: number;

  isVegan: boolean;
  isVegetarian: boolean;
  isHalal: boolean;
  isKosher: boolean;
  isGlutenFree: boolean;

  tagIds: number[];

  /** The PPDS information for the recipe, formatted as html */
  ppdsInfoHtml: string;

  constructor(s?: any) {
    super(s);

    if (s) {
      if (s.allergens) this.allergens = new AllergenValues(s.allergens);
      if (s.nutrition) this.nutrition = new NutritionValues(s.nutrition);
    }
  }

  /** Returns true if nutrient data is complete and should be displayed */
  get showNutrientData(): boolean {
    return ((this.publicNutrition & 1) === 1) && this.nutritionComplete;
  }

  /** Returns true if allergen data is complete and should be displayed */
  get showAllergenData(): boolean {
    return ((this.publicNutrition & 2) === 2) && this.allergensComplete;
  }

}

export interface RecipeGroup {
  id: number | null;
  label: string;
  recipes: RecipeSearchResult[];
}
